import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpService } from './core/http.service';
import { ResponseData } from './model/response.model';
import { URLService } from './_url.service';
@Injectable({
  providedIn: 'root'
})

export class NotificationService {

  constructor(private httpService: HttpService, private URLService: URLService) { }

  GetMyNotificationCount(): Observable<ResponseData> {
    return this.httpService.get(this.URLService.GetMyNotificationCountUrl);
  }

  GetMyNotifications(start: number): Observable<ResponseData> {
    return this.httpService.get(this.URLService.GetMyNotificationsUrl, { start: start });
  }

  GetTopMyNotifications(): Observable<ResponseData> {
    return this.httpService.get(this.URLService.GetTopMyNotificationsUrl);
  }

}
